import { render, staticRenderFns } from "./LinkP.vue?vue&type=template&id=014fc47c&scoped=true&"
import script from "./LinkP.vue?vue&type=script&lang=js&"
export * from "./LinkP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014fc47c",
  null
  
)

export default component.exports